<template lang="pug">
.m-card
  .m-card-header(:id="'heading-cs-' + id" :data-bs-target="'#collapse-cs-' + id" :aria-controls="'collapse-cs-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_CS", 1) }}
  .m-card-body.collapse.show(:id="'collapse-cs-' + id" :aria-labelledby="'heading-cs-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T
          .odds-group  
            .col
              template(v-for="item in cs1")
                template(v-if="moreItems['cso'][item] && moreItems['cso'][item][5] !=  null && moreItems['cso'][item][5] != 0 && moreItems['cso'][item][5] != ''")
                  OddsItem(:odds="moreItems['cso'][item] " idx=5 :typ="oddsType" dataType="3" :label="item")
                template(v-else)
                  OddsDisabled
            .col
              template(v-for="item in cs2")
                template(v-if="moreItems['cso'][item] && moreItems['cso'][item][5] !=  null && moreItems['cso'][item][5] != 0 && moreItems['cso'][item][5] != ''")
                  OddsItem(:odds="moreItems['cso'][item] " idx=5 :typ="oddsType" dataType="3" :label="item")
                template(v-else)
                  OddsDisabled
            .col
              template(v-for="item in cs3")
                template(v-if="moreItems['cso'][item] && moreItems['cso'][item][5] !=  null && moreItems['cso'][item][5] != 0 && moreItems['cso'][item][5] != ''")
                  OddsItem(:odds="moreItems['cso'][item] " idx=5 :typ="oddsType" dataType="3" :label="item")
                template(v-else)
                  OddsDisabled
        .odds-wrapper(v-if="$helpers.objSize(moreItems['csho']) > 0 && (mode == 0 || mode == 2)") 
          .m-label-wrap
            .m-label H.T
          .odds-group
            .col
              template(v-for="item in csh1")
                template(v-if="moreItems['csho'][item] && moreItems['csho'][item][5] !=  null && moreItems['csho'][item][5] != 0 && moreItems['csho'][item][5] != ''")
                  OddsItem(:odds="moreItems['csho'][item] " idx=5 :typ="oddsType" dataType="3" :label="item")
                template(v-else)
                  OddsDisabled
            .col
              template(v-for="item in csh2")
                template(v-if="moreItems['csho'][item] && moreItems['csho'][item][5] !=  null && moreItems['csho'][item][5] != 0 && moreItems['csho'][item][5] != ''")
                  OddsItem(:odds="moreItems['csho'][item] " idx=5 :typ="oddsType" dataType="3" :label="item")
                template(v-else)
                  OddsDisabled
            .col
              template(v-for="item in csh3")
                template(v-if="moreItems['csho'][item] && moreItems['csho'][item][5] !=  null && moreItems['csho'][item][5] != 0 && moreItems['csho'][item][5] != ''")
                  OddsItem(:odds="moreItems['csho'][item] " idx=5 :typ="oddsType" dataType="3" :label="item")
                template(v-else)
                  OddsDisabled
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-cs-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-cs-' + id"
//-     :aria-controls="'collapse-cs-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_CS", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-cs-' + id"
//-     :id="'collapse-cs-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .three-column(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .three-column-content
//-             .three-column-group
//-               .three-column-odd-area(v-for="item in cs1")
//-                 .three-column-odd-area-oddtype
//-                   p.mb-0 {{ item }}
//-                 .three-column-odd-area-group
//-                   template(v-if="moreItems['cso'][item] && moreItems['cso'][item][6] !=  null && moreItems['cso'][item][5] != 0 && moreItems['cso'][item][5] != ''")
//-                     OddsItem(:odds="moreItems['cso'][item] " idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-             .three-column-group
//-               .three-column-odd-area(v-for="item in cs2")
//-                 .three-column-odd-area-oddtype(:class="{ 'notAOS' : item != 'AOS' }")
//-                   p.mb-0 {{ item }}
//-                 .three-column-odd-area-group
//-                   template(v-if="moreItems['cso'][item] && moreItems['cso'][item][6] !=  null && moreItems['cso'][item][5] != 0 && moreItems['cso'][item][5] != ''")
//-                     OddsItem(:odds="moreItems['cso'][item] " idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-             .three-column-group
//-               .three-column-odd-area(v-for="item in cs3")
//-                 .three-column-odd-area-oddtype
//-                   p.mb-0 {{ item }}
//-                 .three-column-odd-area-group
//-                   template(v-if="moreItems['cso'][item] && moreItems['cso'][item][6] !=  null && moreItems['cso'][item][5] != 0 && moreItems['cso'][item][5] != ''")
//-                     OddsItem(:odds="moreItems['cso'][item] " idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-         .three-column(v-if="$helpers.objSize(moreItems['csho']) > 0 && (mode == 0 || mode == 2)")
//-           .normal-title {{ $t("ui.half_time") }}
//-           .three-column-content
//-             .three-column-group
//-               .three-column-odd-area(v-for="item in csh1")
//-                 .three-column-odd-area-oddtype
//-                   p.mb-0 {{ item }}
//-                 .three-column-odd-area-group
//-                   template(v-if="moreItems['csho'][item] && moreItems['csho'][item][6] !=  null && moreItems['csho'][item][5] != 0 && moreItems['csho'][item][5] != ''")
//-                     OddsItem(:odds="moreItems['csho'][item] " idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-             .three-column-group
//-               .three-column-odd-area(v-for="item in csh2")
//-                 .three-column-odd-area-oddtype(:class="{ 'notAOS' : item != 'AOS' }")
//-                   p.mb-0 {{ item }}
//-                 .three-column-odd-area-group
//-                   template(v-if="moreItems['csho'][item] && moreItems['csho'][item][6] !=  null && moreItems['csho'][item][5] != 0 && moreItems['csho'][item][5] != ''")
//-                     OddsItem(:odds="moreItems['csho'][item] " idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
//-             .three-column-group
//-               .three-column-odd-area(v-for="item in csh3")
//-                 .three-column-odd-area-oddtype
//-                   p.mb-0 {{ item }}
//-                 .three-column-odd-area-group
//-                   template(v-if="moreItems['csho'][item] && moreItems['csho'][item][6] !=  null && moreItems['csho'][item][5] != 0 && moreItems['csho'][item][5] != ''")
//-                     OddsItem(:odds="moreItems['csho'][item] " idx=5 :typ="oddsType" dataType="3")
//-                   template(v-else)
//-                     OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      cs1: ['1-0', '2-0', '2-1', '3-0', '3-1', '3-2', '4-0', '4-1', '4-2', '4-3'],
      cs2: ['0-0', '1-1', '2-2', '3-3', '4-4', 'AOS'],
      cs3: ['0-1', '0-2', '1-2', '0-3', '1-3', '2-3', '0-4', '1-4', '2-4', '3-4'],
      csh1: ['1-0', '2-0', '2-1', '3-0', '3-1', '3-2'],
      csh2: ['0-0', '1-1', '2-2', '3-3', 'AOS'],
      csh3: ['0-1', '0-2', '1-2', '0-3', '1-3', '2-3'],
    }
  }
}
</script>
